import Vue from 'vue'
export default {
    softUpdate: function(oldObj, newObj, mainKey) {
        return new Promise((resolve, reject) => {
            if (!(newObj instanceof Object) || !(oldObj instanceof Object)) resolve(oldObj);
        
            let promises = [];

            Object.keys(newObj).map(key => {
                if (newObj[key] instanceof Array) oldObj[key] = Object.assign([], newObj[key]);
                if (newObj[key] instanceof Object) {
                    if (oldObj[key] == null) oldObj[key] = {};
                    promises.push(this.softUpdate(oldObj[key], newObj[key], key).then(value => {
                        oldObj[key] = value;
                    }));
                }
                else if (oldObj[key] != newObj[key]) oldObj[key] = newObj[key];
            });

            if (promises.length) Promise.all(promises).then(() => resolve(oldObj));
            else resolve(oldObj);
        });
   }
}



// WEBPACK FOOTER //
// ./src/helpers/object/index.js